import { apiCall, ApiConfig } from '../../config/api'
import { AsnState } from '../../interfaces/Asn/AsnState'
import { getAsnStateAction } from '../actions/asnStateActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_ASN_STATE } from '../types/asnStateActionsTypes'

export function* getAsnStatesAsync() {
  try {
    const { status, data }: AxiosResponse<AsnState[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.AsnStateApi}/GetList`
    )
    if (status === 200) {
      yield put(getAsnStateAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getAsnStateAction([], serverError.message))
  }
}

export function* watchGetAsnStatesAsync() {
  yield takeEvery(GET_ASN_STATE, getAsnStatesAsync)
}
